import React, { useState } from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileImg from "./../../../assets/images/ProfileImage.png";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
let Notifications = () => {
  const navigate = useNavigate();
  let [NotificationsList, setNotificationsList] = useState([
    {
      notificationType: "Complete",
      name: "Samantha aryton",
      title: "Lorem ipsum dolor sit a...",
      date: "JAN 5, 2022",
      read: true,
    },
    {
      notificationType: "Purchase",
      name: "Samantha aryton",
      title: "Lorem ipsum dolor sit a...",
      date: "JAN 5, 2022",
      read: false,
    },
    {
      notificationType: "Complete",
      name: "Samantha aryton",
      title: "Lorem ipsum dolor sit a...",
      date: "JAN 5, 2022",
      read: true,
    },
    {
      notificationType: "Complete",
      name: "Samantha aryton",
      title: "Lorem ipsum dolor sit a...",
      date: "JAN 5, 2022",
      read: true,
    },
    {
      notificationType: "Purchase",
      name: "Samantha aryton",
      title: "Lorem ipsum dolor sit a...",
      date: "JAN 5, 2022",
      read: false,
    },
    {
      notificationType: "Complete",
      name: "Samantha aryton",
      title: "Lorem ipsum dolor sit a...",
      date: "JAN 5, 2022",
      read: true,
    },
  ]);
  return (
    <SideMenu>
      <div className="page-container">
        <div className="page-header-button-main">
          <Button className="page-header-button" variant="text">
            <p className="page-header-button-text">Download</p>
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by Student name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by Student name"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">notification</p>
                <select className="header-dropdown">
                  <option value="All">All</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Yearly">Yearly</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        {NotificationsList.map((v, i) => {
          return (
            <Button
              className="notification-container"
              style={{ backgroundColor: v.read ? "#fff" : "#F4F4F4" }}
              onClick={() => {
                NotificationsList[i].read = true;
                setNotificationsList([...NotificationsList]);
                navigate("/tutor-panel/notifications/view");
              }}
            >
              <img
                src={ProfileImg}
                className="notification-user-profile-image"
              />
              <div style={{ textAlign: "left" }}>
                {v.notificationType === "Complete" ? (
                  <div>
                    <span className="notification-text">{v.name}</span>
                    <span className="notification-type-completed">
                      {v.notificationType}
                    </span>
                    <span className="notification-text">{v.title}</span>
                  </div>
                ) : (
                  <div>
                    <span className="notification-message">Congratulate</span>
                    <span className="notification-text">{v.name}</span>
                    <span className="notification-type-completed">
                      {v.notificationType} your
                    </span>
                    <span className="notification-text">{v.title}</span>
                    <span className="notification-message">course</span>
                  </div>
                )}
                <p className="notification-date">{v.date}</p>
              </div>
            </Button>
          );
        })}
      </div>
    </SideMenu>
  );
};
export default Notifications;
